<template>
  <gmap-map
    v-bind="options"
    id="map"
    class="mpc-map"
  >
  </gmap-map>
</template>

<script>
  import {gmapApi} from 'vue2-google-maps'

  const cool_grey = [
    {
      featureType: 'landscape',
      elementType: 'labels',
      stylers: [{
        visibility: 'off'
      }]
    }, {
      featureType: 'transit',
      elementType: 'labels',
      stylers: [{
        visibility: 'off'
      }]
    }, {
      featureType: 'poi',
      elementType: 'labels',
      stylers: [{
        visibility: 'off'
      }]
    }, {
      featureType: 'water',
      elementType: 'labels',
      stylers: [{
        visibility: 'off'
      }]
    }, {
      featureType: 'road',
      elementType: 'labels.icon',
      stylers: [{
        visibility: 'off'
      }]
    }, {
      stylers: [{
        hue: '#00aaff'
      }, {
        saturation: -100
      }, {
        gamma: 2.15
      }, {
        lightness: 12
      }]
    }, {
      featureType: 'road',
      elementType: 'labels.text.fill',
      stylers: [{
        visibility: 'on'
      }, {
        lightness: 24
      }]
    }, {
      featureType: 'road',
      elementType: 'geometry',
      stylers: [{
        lightness: 57
      }]
    }
  ]

  export default {
    name: 'GoogleMap',
    data() {
      return {
        options: {
          zoom: 14,
          disable_auto_zoom: true,
          location: '',
          disable_auto_location: false,
          disable_ui: false,
          disable_scroll_wheel: false,
          style: cool_grey,
          center: {
            lat: 51.2122376,
            lng: 24.706066
          },
          'markers': [{
            'location': {'latitude': 51.2122376, 'longitude': 24.706066},
            'icon_url': 'https://classic.com.ua/wp-content/plugins/mpc-massive/assets/images/defaults/location.png'
          }, {
            'location': {'latitude': 51.2201632, 'longitude': 24.7105416},
            'icon_url': 'https://classic.com.ua/wp-content/plugins/mpc-massive/assets/images/defaults/location.png'
          }]
        }
      }
    },
    computed: {
      google: gmapApi
    },
  }
</script>

<style>

</style>
